import React from 'react'
import PropTypes from 'prop-types'

import DealerRow from './DealerRow'


import GoogleMap from './../googlemaps/GoogleMap'


import DataLoader from '../data/DataLoader'


class DealerList extends React.Component {


  constructor(props){
    super()

    this.state ={
        countries: [],
        currentCountry: '',


        cities: [],
        currentCity: '',

        dealers: [],
        selectedDealerList:[],
        currentDealer:{},
        mouseHoverDealerId:null,
        numberOfDealers: 0,
        searchInFocus:false,
        searchError: false

    }


    //this.currentDealers =  this.currentDealers.bind(this);
    this.selectDealer = this.selectDealer.bind(this);
    this.search = this.search.bind(this);
    this.setCurrentDealers = this.setCurrentDealers.bind(this)

    this.markerHover = this.markerHover.bind(this)
    this.markerRollOff = this.markerRollOff.bind(this)

    this.searchFocus = this.searchFocus.bind(this)
    this.searchBlur = this.searchBlur.bind(this)
    this.keyPress = this.keyPress.bind(this)

    this.setData = this.setData.bind(this)


    this.trackEvent = this.trackEvent.bind(this)
  }










  mapDealerListCB(){
    let currentCity,dealers,currentDealer:{},selectedDealerList;
    this.setState({currentCity,dealers,currentDealer:{},selectedDealerList})

  }

  selectDealer(id_str){


    //console.log("id_str",id_str);

    if(id_str){

      let id = (id_str)?  id_str : parseFloat(this.refs.dealerSelect.value)

      //console.log("id",id);
                          ///   this.state.dealers
      let currentDealer =  this.state.dealersData.filter((item,i)=>{
            //console.log(item.id===id,item.id,id);
            return(item.id===id)
      })[0]

      let selectedDealerList = [currentDealer]

      this.setState({currentDealer})

      //console.log('currentDealer',currentDealer);

      if(this.props.selectedDealerListCB){
        this.props.selectedDealerListCB(currentDealer);
      }

      if(window.innerWidth < 481){

        // scrollTo #dealerList if it's on mobile
        //document.querySelector('#dealerList').scrollIntoView({behavior:'smooth'})
        let scrollTo =  document.querySelector('#map').getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo(0,scrollTo);
        /// console.log("scrollTo",scrollTo);

      }

      console.log('Dealer selected: '+currentDealer.title.rendered);
      this.trackEvent('Dealer selected: '+currentDealer.title.rendered)


    }else{
        // Deselect dealer
      this.setState({currentDealer:false})
    }




  }

  markerHover(id_str){

    //console.log("markerHover(id_str)",id_str);
    this.setState({mouseHoverDealerId:id_str});
  }

  markerRollOff(id_str){
        this.setState({mouseHoverDealerId:null});
  }

  setCurrentDealers(dealers){
      //  console.log("Dealers",dealers);
        this.setState({selectedDealerList:dealers})
  }

  search(){

    let searchTerm = this.refs.searchInput.value
    this.setState({searchTerm, currentDealer:false})
    this.trackEvent('Search: '+searchTerm)
  }


  trackEvent(evt){


        console.log('Track:',evt);
        if(window.gtag){
          console.log('trigger Gtag')
         // window.ga('send', 'event', 'Dealer',evt);
          window.gtag('event', evt, {
            'event_category': 'Dealer',
          });
        }else{
          console.warn("Google GA is not available")
        }
  }


  componentDidMount(){
  }



  componentDidUpdate(prevProps,prevState){


    // send a callback to let whoever is listening know that we've got a selected dealer
    if(this.state.selectedDealerList){
      if(this.props.selectedDealerListCB){
          //this.props.selectedDealerListCB(this.state.selectedDealerList,this.state.selectedDealer)
      }
    }

    if(this.props.clickedFeaturedDealer){

      if(this.props.clickedFeaturedDealer.id !== prevProps.clickedFeaturedDealer.id){
        //console.log("updateFeaturList",this.props.clickedFeaturedDealer);
          let searchTerm = this.props.clickedFeaturedDealer.acf.street_address+", "+this.props.clickedFeaturedDealer.acf.city +", "+this.props.clickedFeaturedDealer.acf.country
        //  console.log("searchTerm",searchTerm);
          this.refs.searchInput.value = searchTerm
          this.setState({searchInFocus:true})
          this.search();
          this.selectDealer(this.props.clickedFeaturedDealer.id);
        //this.setState({searchTerm:this.props.clickedFeaturedDealer});
      }
    }

    // Fieed in all dealerSelect
    //let selectedDealerList = this.state.dealersData
    //this.state.selectedDealerList
  }

  searchFocus(){
    //console.log("Search Focus");
    this.setState({searchInFocus:true,searchError:false})
  }

  searchBlur(){
      //console.log("Search Blur");
    if(!this.refs.searchInput.value){
      this.setState({searchInFocus:false})
    }
  }

  keyPress(e){
    //console.log(e);
    //console.log(`Pressed keyCode ${e.key}`)
    if(e.key==='Enter'){
      this.search()
    }
  }


  setData(data){
    //console.log('setData',data);
    this.setState({dealersData:data})
  }



  render () {

      //console.log('DealerList',this);

      if(!this.state.dealersData){
        //return null;
      }


      let currentDealer = this.state.currentDealer

        let content = {}



      let placeholder = window.placeholderText || "placeholder";
      let searchLabel = window.searchButtonText|| "searchLabel";

    return(
        <DataLoader dealers setData={this.setData} >
          {this.state.dealersData?
          <div className="dealer-list">
              <div className="content-row">
                   { /*<div>(loaded dealers: { this.state.numberOfDealers})</div> */ }
                  <div className="dealer-select-row">

                    <div className="search">
                        <div className={"text-field "+((this.state.searchInFocus)? "focus" : " blurred" )+(this.state.searchError? " error" : "")}>
                          <div className="placeholder" dangerouslySetInnerHTML={{__html:placeholder}}></div>
                          <input type="text" ref="searchInput"  onFocus={this.searchFocus} onBlur={this.searchBlur} onKeyPress={this.keyPress}  />
                        </div>
                        <div className={"submit-button "+((!this.state.searchInFocus)? " inactive" : " " )+(this.state.searchError? " error" : " ")} onClick={this.search} dangerouslySetInnerHTML={{__html:searchLabel}}></div>
                    </div>

                  </div>
                </div>
                  {/*(currentDealer.title)?

                      <div>
                          <h2 dangerouslySetInnerHTML={{__html:currentDealer.title.rendered }} />
                          <div>
                              <div dangerouslySetInnerHTML={{__html:currentDealer.acf.street_address }} />
                              <div dangerouslySetInnerHTML={{__html:currentDealer.acf.post_code }} />
                              <div dangerouslySetInnerHTML={{__html:currentDealer.acf.city }} />

                              <div dangerouslySetInnerHTML={{__html:currentDealer.acf.tel }} />
                              <div dangerouslySetInnerHTML={{__html:currentDealer.acf.fax }} />
                              <div dangerouslySetInnerHTML={{__html:currentDealer.acf.email }} />
                                <div dangerouslySetInnerHTML={{__html:currentDealer.acf.website }} />
                          </div>
                        </div>
                    : null
                    */  }

                <div className="map-list-container">
                <GoogleMap
                  markerList={this.state.dealersData}
                  searchTerm={this.state.searchTerm}
                  setCurrentDealers={this.setCurrentDealers}
                  activeMarker={currentDealer}
                  markerClick={this.selectDealer}
                  markerHover={this.markerHover}
                  markerRollOff={this.markerRollOff}
                  mouseHoverDealerId={this.state.mouseHoverDealerId}
                  searchError={()=>{this.setState({searchError:true})}} />

                <div className="map-dealer-list" id="dealerList">

                      {
                          this.state.selectedDealerList.map((item,i)=>{

                              return <DealerRow
                                        onClick={this.selectDealer}
                                        onClose={this.selectDealer}
                                        key={'d'+i} {...item}
                                        selectedDealer={currentDealer}
                                        mouseHoverDealerId={this.state.mouseHoverDealerId}
                                        highLightId={this.markerHover}
                                        onlyDealer={(this.state.selectedDealerList.length===1)} />
                          })

                      }

                  </div>
                </div>
                <div className="content-row">

              </div>




          </div>
          : null }
          </ DataLoader>
    )

  }
}

export default DealerList
